import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { createAppConfig } from './app.config.shared';

export const appConfig = createAppConfig([
  provideRouter(routes, withComponentInputBinding())
]);
